/* eslint-disable @typescript-eslint/no-explicit-any */
import type { MigrationManifest } from 'redux-persist';

export const migrations: MigrationManifest = {
	1: (state: any) => {
		if (!state) return state;

		return {
			...state,
			applications: {
				...state.applications,
				currentApplicationActions: {
					...state.applications?.currentApplicationActions,
					downloadApplication: state.applications?.currentApplicationActions?.downloadApplication ?? {
						isAllow: false,
						errorMessage: undefined,
					},
					downloadTaxForm: state.applications?.currentApplicationActions?.downloadTaxForm ?? {
						isAllow: false,
						errorMessage: undefined,
					},
				},
			},
		};
	},
};
